import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import axios from "axios";

import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { useParams } from "react-router";

import NavBar from "Components/NavBar";
import DateRangePicker from "Components/DateRangePicker";
import Typography from "@mui/material/Typography";

import Moment from "moment";
import { extendMoment } from "moment-range";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { itIT } from "@material-ui/data-grid";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  gridClasses,
} from "@mui/x-data-grid";
import columnsArticolo from "Utils/Datagrid/Articolo/VendutoGiornaliero/Articolo";
import CustomToolbar from "Utils/Datagrid/CustomToolbar";
// Filtri
import MultipleSelectCheckmarks from "Components/CheckmarkSelect";
import Button from "@mui/material/Button";
import configData from "CONFIGURAZIONE.json";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TocIcon from "@material-ui/icons/Toc";
import TimelineIcon from "@material-ui/icons/Timeline";
import { Pie } from "react-chartjs-2";
import { TextField } from "@material-ui/core";
import HomeIcon from "@mui/icons-material/Home";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import KitchenIcon from "@mui/icons-material/Kitchen";
import { PieIncassoAggregatoData } from "Utils/Grafici/Reparto/IncassoAggregato";
import { getColors } from "Utils/Funzioni/Grafici";
import DettaglioVendutoGiornalieroArticolo from "Pages/Vendite/Articolo/VendutoGiornaliero/PopUp/DettaglioVendutoGiornalieroArticolo";
import CercaArticolo from "Pages/Vendite/Articolo/VendutoGiornaliero/PopUp/CercaArticolo";
import { createContext, useContext } from 'react';
import { LicenzaContext } from 'Utils/LicenzaContext';
import LoadingSpinner from "Components/LoadingSpinner";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Myparticles from "Components/MyParticles";

import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

ChartJS.register(ArcElement, Tooltip, Legend);

const BreadcrumbsReference = (idCliente) => {
  return [
    {
      label: "HOME",
      href: `/${idCliente}`,
      icon: <HomeIcon fontSize="small" />,
    },
    {
      label: "Articoli",
      href: `/${idCliente}/Articoli`,
      icon: <KitchenIcon fontSize="small" />,
    },
    {
      label: "Venduto Giornaliero",
      href: `/${idCliente}/Articoli`,
      icon: <KitchenIcon fontSize="small" />,
    },
  ];
};

var server = configData.general_api_end_point;
const moment = extendMoment(Moment);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  container: {
    margin: theme.spacing(1),
    marginTop: "10vh",
    zIndex: 1,
  },
  paper: {
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(2),
    },
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1),
    },
    flexGrow: 1,
  },
  filterExpansionBar: {
    marginBottom: theme.spacing(1),
  },
  searchbar: {
    padding: theme.spacing(1),
  },
  scontriniGrid: {
    height: "80vh",
  },
  card: {
    [theme.breakpoints.up("md")]: {
      width: "20%",
    },
    [theme.breakpoints.down("md")]: {
      width: "100vw",
      height: "100%",
    },
  },
}));

function VendutoGiornalieroArticolo() {
  // Stati //
  const licenzaContext = useContext(LicenzaContext);
  // Storia
  let idCliente = licenzaContext.licenza.id_cliente;
  let utente = licenzaContext.licenza.utente;
  const configurazioneReport = licenzaContext.licenza.configurazione.Pagine.Vendite.VendutoGiornalieroArticolo;

  const classes = useStyles();
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("lg"));
  const tablet = useMediaQuery(theme.breakpoints.up("sm"));
  const mobile = useMediaQuery(theme.breakpoints.up("xs"));

  const firstIndex = 0;
  const [columns, setColumns] = React.useState(columnsArticolo);
  const [tabSelezionato, setTabSelezionato] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [dataDettaglio, setDataDettaglio] = React.useState([]);
  const [vendutoPerNegozio, setVendutoPerNegozio] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [caricamentoDati, aggiornaCaricamento] = React.useState(false);
  const [apriCercaArticoloPage, setApriCercaArticoloPage] = React.useState(false);
  const [openErrorDialog, setOpenErrorDialog] = React.useState(false);
  const [filtroDescrizioneArticolo, setFiltroDescrizioneArticolo] = React.useState();
  ////////////////////////////////////////////////////
  // FILTRI

  // Negozio
  const [filtroNegozi, setFiltroNegozi] = useState([]);

  const [filtroEan, setFiltroEan] = useState();

  const [filtroCodiceArticolo, setFiltroCodiceArticolo] = useState();

  const [intervalloGiorni, setIntervalloGiorni] = useState([
    {
      startDate: new Date().setDate(new Date().getDate() - 1),
      endDate: new Date().setDate(new Date().getDate() - 1),
      key: "selection",
    },
  ]);

  // Intervallo date
  const [filtroIntervalloData, setFiltroIntervalloData] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  ////////////////////////////////////////////////////

  const [idNegozi, setIdNegozi] = useState([]);
  useEffect(() => {
    let negozi = [];
    axios.get(`${server}/${idCliente}/${utente}/negozi`).then((response) => {
      let configurazioni = {};
      if (response.status == 200) {
        response.data.forEach((negozio) => {
          if (configurazioneReport.negoziSelectBox.showOnlyNegozi.includes(negozio.id_negozio) || configurazioneReport.negoziSelectBox.showOnlyNegozi.length === 0){
            configurazioni[negozio.id_negozio]=negozio.configurazione
            negozi.push({
              chiave: negozio.id_negozio,
              valore: negozio.nome_negozio,
          });
          } 
        });
        setIdNegozi(negozi);
        setFiltroNegozi(negozi[0].chiave);
      }
    });
  }, []);

  //"${server}/scontrini/0255/cercaPerData",
  const requestDati = () => {
    aggiornaCaricamento(true);
    setData([]);
    axios
      .post(`${server}/${idCliente}/articoli/cerca`, getAllFilters())
      .then(function (response) {
        let vendutoGiornaliero = [];
        for (const [index, giorno] of Object.entries(response.data.aggregato)){
          vendutoGiornaliero.push(giorno);
        }
        console.log(vendutoGiornaliero);
        setDataDettaglio(response.data.esplosoPerPDV);
        setData(vendutoGiornaliero);
        aggiornaCaricamento(false);
      })
      .catch(function (error) {
        aggiornaCaricamento(false);
        console.log(error);
      });
  };

  const scaricaExcel = () => {
    aggiornaCaricamento(true);
    axios({
      url: `${server}/${idCliente}/articoli/cerca/xls`, //your url
      method: "POST",
      responseType: "blob", // important
      data: getAllFilters(),
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      aggiornaCaricamento(false);
      link.setAttribute("download", "report.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    }).catch(function (error) {
      aggiornaCaricamento(false);
      console.log(error);
    });
  };

  const getAllFilters = () => {
    let filter = {};
    try {
      filter = {
        dataDa: `${moment(intervalloGiorni[0].startDate).format("DD/MM/YYYY")}`,
        dataA: `${moment(intervalloGiorni[0].endDate).format("DD/MM/YYYY")}`,
        puntiVendita: filtroNegozi,
        eanArticolo: filtroEan,
        codiceArticolo: filtroCodiceArticolo,
      };
    } catch {}

    console.log(filter);
    return filter;
  };

  const VendutoGiornalieroArticoloRendered = () => {
    if (desktop || tablet)
      return (
        <div className={classes.root}
        >
          <NavBar
          openVendite={true}
          openArticoli={true}
            idCliente={idCliente}
            breadcrumbsReference={BreadcrumbsReference(idCliente)}
          />
          <LoadingSpinner open={caricamentoDati}/>
          <Container className={classes.container} maxWidth="xl" style={{
          marginTop: '3vw',
          filter: !configurazioneReport.attivo ? 'blur(20px)' : "",
          pointerEvents: !configurazioneReport.attivo ? 'none' : "",
        }}>
            <Accordion style={{ marginTop: "4vh" }} defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="h6">Barra di Ricerca</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Paper
                  elevation={6}
                  style={{
                    padding: 11,
                    margin: "auto",
                    marginTop: 13,
                    marginBottom: 13,
                    width: "100%",
                  }}
                >
                  <Grid
                    container
                    direction="row"
                    className={classes.searchbar}
                    spacing={1}
                  >
                    <Grid item xl={4} md={4} direction="row">
                      <DateRangePicker
                        state={intervalloGiorni}
                        setState={setIntervalloGiorni}
                      />
                    </Grid>
                    <Grid container item xl={8} md={8}>
                      <Grid item xl={6} md={6}>
                        <MultipleSelectCheckmarks
                          label={"Selezione Negozi"}
                          selezioneMultipla={true}
                          items={idNegozi}
                          setState={setFiltroNegozi}
                        />
                      </Grid>
                      <Grid item xl={3} md={3}>
                        <TextField
                          id="outlined-basic"
                          label="Codice Articolo"
                          variant="outlined"
                          // disabled={!configurazioneReport.codiceArticoloTextField.attivo}
                          value={filtroCodiceArticolo}
                          onChange={(event) => {
                            setFiltroCodiceArticolo(event.target.value);
                          }}
                        />
                      </Grid>
                      <Grid item xl={3} md={3}>
                        <TextField
                          id="outlined-basic"
                          label="EAN"
                          // disabled={!configurazioneReport.eanTextField.attivo}
                          variant="outlined"
                          value={filtroEan}
                          onChange={(event) => {
                            setFiltroEan(event.target.value);
                          }}
                        />
                      </Grid>
                      <Grid container xl={3} md={3} spacing={2}>
                        <Grid item xl={8} md={8}>
                          <TextField
                            id="outlined-basic"
                            label="Cerca Descrizione"
                            variant="outlined"
                            // disabled={!configurazioneReport.cercaDescrizioneTextField.attivo}
                            value={filtroDescrizioneArticolo}
                            onChange={(event) => {
                              setFiltroDescrizioneArticolo(event.target.value);
                            }}
                          />
                        </Grid>
                        <Grid item xl={4} md={4}>
                          <Button
                            fullWidth
                            disabled={filtroNegozi.length == 0 } //&& !configurazioneReport.cercaArticoloDescrizioneButton.attivo
                            variant="contained"
                            onClick={() => {
                              setApriCercaArticoloPage(true);
                            }}
                          >
                            Cerca Articolo
                          </Button>
                        </Grid>
                        
                      </Grid>
                      <Grid
                        container
                        item
                        xl={12}
                        md={12}
                        justifyContent="center"
                      >
                        <Button
                          fullWidth
                          // disabled={!configurazioneReport.visualizzaReportButton.attivo}
                          variant="contained"
                          onClick={() => {
                            requestDati();
                          }}
                          style={{
                            margin: 5,
                          }}
                        >
                          Visualizza
                        </Button>
                        <Button
                          fullWidth
                          // disabled={!configurazioneReport.scaricaExcelButton.attivo}
                          variant="contained"
                          onClick={() => {
                            scaricaExcel();
                          }}
                          style={{
                            margin: 5,
                          }}
                          
                        >
                          {/* {configurazioneReport.scaricaExcelButton.buttonLabel} */}
                          Scarica Excel
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </AccordionDetails>
            </Accordion>

            <Paper>
              <DataGrid
                style={{ flexGrow: 1, height: "75vh" }}
                components={{
                  Toolbar: CustomToolbar,
                }}
                getRowId={(row) => row.data}
                rows={data}
                columns={columns}
                disableSelectionOnClick
                localeText={itIT.props.MuiDataGrid.localeText}
                loading={caricamentoDati}
                onRowDoubleClick={(event) => {
                  setOpen(true);
                  console.log(dataDettaglio[event.row.data]);
                  setVendutoPerNegozio(dataDettaglio[event.row.data]);
                }}
              />
            </Paper>
          </Container>
          <React.Fragment>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xl">
              <DialogContent>
                <DettaglioVendutoGiornalieroArticolo
                  data={vendutoPerNegozio}
                />
              </DialogContent>
            </Dialog>
          </React.Fragment>
          <React.Fragment>
            <Dialog open={apriCercaArticoloPage} onClose={() => setApriCercaArticoloPage(false)} maxWidth="xl">
              <DialogContent>
                <CercaArticolo
                  informazioni={
                    {
                    dataDa: `${moment(intervalloGiorni[0].startDate).format("DD/MM/YYYY")}`,
                    dataA: `${moment(intervalloGiorni[0].endDate).format("DD/MM/YYYY")}`,
                    puntiVendita: filtroNegozi,
                    descrizioneArticolo: filtroDescrizioneArticolo,
                    callBackSetEan: setFiltroEan,
                    callBackSetCodiceArticolo: setFiltroCodiceArticolo,
                    callBackSetDescrizioneArticolo: setFiltroDescrizioneArticolo,
                    callBackChiudi: setApriCercaArticoloPage
                    }
                  }
                />
              </DialogContent>
            </Dialog>
          </React.Fragment>
          
          <Myparticles numberAtoms={60}/>
        </div>
      );
    if (tablet || mobile) return <div className={classes.root}> </div>;
  };
  return <> {VendutoGiornalieroArticoloRendered()} </>;
}

export default VendutoGiornalieroArticolo;
